<template>
    <div>
        <img v-if="menu.custom_dine_in_icon&&type=='dine_in'" :style="{height:'auto',width:customIconWidth}" :src="customDineInSrc" alt="Dine In"/>
        <img v-else-if="menu.custom_take_out_icon&&type=='take_away'" :style="{height:'auto',width:customIconWidth}" :src="customTakeOutSrc" alt="Take away"/>
        <Icon v-else :name="iconName" :size="size" :color="color" :options="{
            'stroke-width': 2
        }" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Icon from './Icon.vue'

export default {
    props: {
        type: String, 
        custom: Boolean,
        size: {
            type: [String, Number],
            default: function() {
                return this.orderTypeIconSize != '' ? this.orderTypeIconSize : '4rem'
            }

        },
        color: String
    },
    components: {
        Icon
    },
    computed: {
        ...mapGetters(["menu","language"]),
        ...mapGetters("Theme", [
            "orderTypeIconSize"
        ]),
        customIconWidth() {
            return this.menu.hide_kiosk_icon_text ? (this.orderTypeIconSize ? this.orderTypeIconSize : '14rem' ): this.size;
        },
        iconName() {
            return {
                'dine_in': 'home',
                'take_away': 'shopping-bag',
            }[ this.type ] || 'package'
        },
        customDineInSrc() {
            if (this.menu[`custom_dine_in_icon_${this.language}`])
                return this.menu[`custom_dine_in_icon_${this.language}`];
            return this.menu.custom_dine_in_icon;
        },
        customTakeOutSrc() {
            if (this.menu[`custom_take_out_icon_${this.language}`])
                return this.menu[`custom_take_out_icon_${this.language}`];
            return this.menu.custom_take_out_icon;
        }
    },

}
</script>

<style>

</style>